<template>
  <v-navigation-drawer
    persistent
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    :width="370"
  >
    <v-list>
      <v-list-item>
        <v-list-item-title class="text-h6 cursor-pointer" @click="goBack">
          <v-icon>keyboard_arrow_left</v-icon> Go Back
        </v-list-item-title>
        <v-icon @click="drawer = false" v-if="isMobile">close</v-icon>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="ma-2 rounded border--question">
        <v-list-item-icon>
          <v-icon
            :color="getQuestionTypeColor(0)"
            v-text="getQuestionTypeIcon(0)"
            >assignment</v-icon
          >
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Survey Details & Intro</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-for="(question, i) in survey_questions">
        <v-list-item :key="i" class="ma-2 rounded border--question">
          <v-list-item-icon>
            <v-icon
              :color="getQuestionTypeColor(question.questionTypeId)"
              v-text="getQuestionTypeIcon(question.questionTypeId)"
            ></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="question.question"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-menu absolute>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="$emit('moveup', i)" v-if="i > 0">
                  <v-list-item-icon>
                    <v-icon>arrow_upward</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Move up</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="$emit('movedown', i)"
                  v-if="i < survey_questions.length - 1"
                >
                  <v-list-item-icon>
                    <v-icon>arrow_downward</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Move down</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('duplicate', i)">
                  <v-list-item-icon>
                    <v-icon>content_copy</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Duplicate</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('delete', i)">
                  <v-list-item-icon>
                    <v-icon>delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
    <v-menu absolute>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          x-large
          class="border--accent border--dashed mx-2"
          width="95%"
          v-bind="attrs"
          v-on="on"
          color="accent"
        >
          <v-icon class="mr-1">add_circle</v-icon> Add new question
        </v-btn>
      </template>
      <survey-question-type-list
        v-on:select="$emit('addquestion', $event)"
      ></survey-question-type-list>
    </v-menu>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import questionTypes from "@/helpers/mixins/questionTypes";
import SurveyQuestionTypeList from "@/components/surveys/SurveyQuestionTypeList";
export default {
  name: "BuilderLeftNavigation",
  components: {
    "survey-question-type-list": SurveyQuestionTypeList
  },
  mixins: [questionTypes],
  data: () => ({
    clipped: true,
    miniVariant: false
  }),
  computed: {
    drawer: {
      get() {
        return this.common_drawer;
      },
      set(val) {
        this.$store.dispatch("common/setDrawer", val);
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters({
      survey: "survey/edit_survey",
      survey_questions: "survey/survey_questions",
      survey_question_types: "lookup/survey_question_types",
      common_drawer: "common/drawer"
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
